// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2380) return "static/chunks/2380-6a7704f098e669bd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"542":"171a18dd1910ec70","2624":"ca7d5a1e957e3f8b","3452":"4d9b530b877a58ab","4516":"f857a6391dcfd08c","4744":"66266e3cb5da5401","6277":"b3929aafb2869f3d","7889":"0de4eb73359d1b11","8426":"882cf3a396ff9801","9050":"439380b36b96b898"}[chunkId] + ".js";
};